module.exports = __webpack_public_path__ + "static/media/logAutoScale.7e9f116e.svg";